import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"
import PopupPlanModel from "../../pages/popup/PopupPlanModel"
import PopupSaleService from "../../pages/popup/PopupSaleService"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';
import moment from "moment";



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { logEvent, gtag, viewItem, addToCart, beginCheckout, purchase } from '../../analytics';

export default function Price() {
    const location = useLocation();
    const { mbData } = useSelector((s) => s.usersReducer);
    const [width, setWidth] = useState(window.innerWidth);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const fileRef = useRef();

    const lang = useSelector(state => state.langReducer.lang);

    const [planToggle, setPlanToggle] = useState(true);

    const [answerView, setAnswerView] = useState(Array(10).fill(false));

    const [planOther, setPlanOther] = useState(0);
    const [planOther1, setPlanOther1] = useState(false);
    const [planOther2, setPlanOther2] = useState(false);
    const [mainCard, setMainCard] = useState(null);
    const [nocardbuttonType, setnocardbuttonType] = useState('');
    const [paylist, setpaylist] = useState([]);
    const [paylistcker, setpaylistcker] = useState([{}]);
    const [invoicecker, setinvoicecker] = useState(false);
    const [coupon, setCoupon] = useState([]);

    const [paypopflag, setpaypopflag] = useState(false);
    const PAYSTATION_ORIGINS = [
        "https://secure.xsolla.com",
        "https://sandbox-secure.xsolla.com"
    ];
    let savedAccountAdded = false;

    const [questionSample, setQuestionSample] = useState([
        'Q1. UModeler X Plus와 Pro의 차이는 무엇인가요?',
        'Q2. 기존 UModeler 혹은 UModeler X Plus를 에셋 스토어에서 구매하여 사용중입니다. 할인 혜택은 어떻게 되나요?',
        'Q3. 환불 정책은 어떻게 되나요?',
        'Q4. 교육 기관이나 기업이 대량의 라이선스를 구입 시 할인 혜택을 받을 수 있나요?',
        'Q5. UModeler X는 Unity의 어떤 버전에서 사용할 수 있나요?',
        'Q6. 고객 지원은 어떻게 받을 수 있나요?',
        'Q7. UModeler X를 사용하기 위한 컴퓨터 사양은 어떻게 되나요?',
        'Q8. UModeler X의 사용자 가이드나 튜토리얼은 어디에서 확인할 수 있나요?',
        'Q9. UModeler X와 경쟁 제품과의 차별점은 무엇인가요?',
        'Q10. 학교 교육용으로 사용하려면 어떻게 해야 하나요?'
    ]);


    const [questionSampleEn, setQuestionSampleEn] = useState([
        `Q1. What's the difference between UModeler X Plus and Pro?`,
        `Q2. I purchased UModeler or UModeler X Plus from the Asset Store. Is there a discount?`,
        `Q3. What's the refund policy?`,
        `Q4. Do schools or companies get bulk purchase discounts?`,
        `Q5. Which Unity versions are supported?`,
        `Q6. How can I get customer support?`,
        `Q7. What are the system requirements for UModeler X?`,
        'Q8. Where can I find user guides or tutorials?',
        'Q9. What makes UModeler X different from competitors?',
        'Q10. How can I use it for school educational purposes?',
    ]);
    const answerSample = [
        [
            <>
                Pro는 Plus의 모든 기능을 포함하며, 추가적으로 블렌드 쉐입 모드, Curve 컴포넌트, Quadify 툴, Edge Constraints 툴, Text to 3D 컴포넌트 등 더 많은 확장 기능을 제공합니다. 또한 구독 기간 중 지속적인 기능 업데이트가 이루어집니다.
            </>,
            <>
                Pro는 구독 모델로 UModeler 웹사이트에서 누구나 제한 없이 구독할 수 있습니다. 반면, Plus는 Unity Asset Store에서 구매 가능하며, 연 매출 20만 달러 미만의 개인 및 기업만 사용할 수 있습니다.
            </>,
            <>
                더 자세한 비교는<span>공식 매뉴얼의 FAQ</span>를 참고해 주세요.
            </>
        ],
        /* [
            <>
                기존 UModeler 혹은 Plus를 사용 중인 경우 Pro, Art Pass, All-In-One 연 구독 시 특별 업그레이드 할인 혜택이 제공됩니다. (쿠폰과 중복 가능)
            </>,
            <>
                업그레이드 할인을 위해서는<span onClick={navigate(routes.Price)}>가격 페이지</span>를 참고해 주세요.
            </>
        ], */
    ];

    const country = useSelector((state) => state.locationReducer.country.value);
    console.log("country : ", country);
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        
        window.addEventListener("resize", handleResize);
        
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if(invoicecker !== false){
            dispatch(open({
                component:
                    <Popup01
                        max_width={'400px'}
                        x_btn={false}
                        text1={lang === 0 ? '성공적으로 등록되었습니다.\n연 구독 시 50% 할인가로 구매할 수 있습니다.\n* 1회 한정' : 'Successfully registered.\nSubscribe yearly and get 50% off.\n* One-time offer only.'}
                        longButton={'확인'}
                        setFunc={() => {
                            setTimeout(() => {
                                setPlanToggle(false);
                                document.getElementById("scrollmove")?.scrollIntoView({ behavior: "smooth" });
                            }, 300);
                        }}
                    />
            }));
        }
    }, [invoicecker]);
    useEffect(() => {
        fetchData();
    }, [country]);

    useEffect(() => {
        cardData();
        payData();
        CouponListFunc();
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (location.state?.scrollTo) {
            const targetElement = document.querySelector(
                `.${location.state.scrollTo}`
            );
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [location]);

    const [priceProMonth, setPriceProMonth] = useState(28);
    const [priceProYear, setPriceProYear] = useState(280);
    const [PriceProYearsale, setPriceProYearsale] = useState(280);
    
    const [priceArtPassMonth, setPriceArtPassMonth] = useState(19000);
    const [priceArtPassYear, setPriceArtPassYear] = useState(182400);
    const [priceAllInOneMonth, setPriceAllInOneMonth] = useState(33000);
    const [priceAllInOneYear, setPriceAllInOneYear] = useState(316800);

    const [discountPro, setDiscountPro] = useState(0);
    const [discountArtPass, setDiscountArtPass] = useState(0);
    const [discountAllInOne, setDiscountAllInOne] = useState(0);
    const [intervals, setintervals] = useState(false);

    const isEmpty = priceProMonth === 0 || priceProYear === 0 || priceArtPassMonth === 0 || priceArtPassYear === 0 || priceAllInOneMonth === 0 || priceAllInOneYear === 0;

    //const showWon = country === 'KR';
    const showWon = false;
    console.log("showWon : " + showWon + ", and KR : ", (country === 'KR'));

    const fetchData = async () => {
        const result = await API.productPriceList();
        console.log("result : ", result);
        // setPriceProMonth(showWon ? result[0].monthly : result[0].monthlyUSD);
        // setPriceProYear(showWon ? result[0].yearly : result[0].yearlyUSD);
        // setPriceArtPassMonth(showWon ? result[1].monthly : result[1].monthlyUSD);
        // setPriceArtPassYear(showWon ? result[1].yearly : result[1].yearlyUSD);
        // setPriceAllInOneMonth(showWon ? result[2].monthly : result[2].monthlyUSD);
        // setPriceAllInOneYear(showWon ? result[2].yearly : result[2].yearlyUSD);

        setPriceProMonth(result[0].monthlyUSD);
        setPriceProYear(result[0].yearlyUSD);
        setPriceProYearsale(result[0].yearlyUSD);
        setPriceArtPassMonth(result[1].monthlyUSD);
        setPriceArtPassYear(result[1].yearlyUSD);
        setPriceAllInOneMonth(result[2].monthlyUSD);
        setPriceAllInOneYear(result[2].yearlyUSD);

        setDiscountPro(result[0].discount);
        setDiscountArtPass(result[1].discount);
        setDiscountAllInOne(result[2].discount);
    };
    const CouponListFunc = async () => {
        const result = await API.xsollaApis("user/couponlists", { idx: mbData?.idx });
        if(result?.status === 200){
            let lists = [];
            result?.result?.couponsendlist?.filter(item => item?.status*1 === 0)?.map((x, i) => {
                let coupongrouplists = result?.result?.coupongrouplist?.find(item => item?.idx*1 === x?.couponIdx*1);
                x.issueType = coupongrouplists?.targetType;
                x.discount = coupongrouplists?.discount;
                x.issueDate = moment(coupongrouplists?.create_dt).format('YYYY-MM-DD HH:mm:ss');
                x.statusTxt = x?.status === 0 ? '미사용' : x?.validityDate < moment().format('YYYY-MM-DD HH:mm:ss') ? '만료' : '사용';
                lists.push(x);
                //return x;
            });
            //console.log(lists);
            setCoupon(lists);
        }
    }
    const payData = async () => {
        const result = await API.xsollaApis("user/XsolaApipayMentlist", { idx: mbData?.idx });
        if(result?.status === 200){
            if(result?.result?.filter(item => item?.ingstate*1 === 1)?.length > 0){
                setpaylist(result?.result?.filter(item => item?.ingstate*1 === 1));
            } else {
                setpaylist(result?.result?.filter(item => item?.ingstate*1 === 4));
            }
            setpaylistcker(result?.result);
            console.log(result);
        }
    }

    const cardData = async () => {
        const result = await API.xsollaApis("user/XsolaApiCardlist", { idx: mbData?.idx });
        console.log(result);
        if(result?.status === 200){
            //setMainCard(result?.result);
            setMainCard(result?.result);
        }
    }
    const payFunc = (type) => {
        if (!mbData?.idx) {
            navigate('/Login');
            return;
        }

        // 구매 시도 이벤트 추적
        logEvent(
            'Purchase',
            'Attempt',
            type,  // 'pro', 'art_pass', 'All-In-One' 등
            mbData?.idx
        );        

        const price = planToggle ? priceProMonth : priceProYear;
        const productName = 'UModeler X Pro';
        const productId = 'umodeler_x_pro';

        // 상품 조회 이벤트
        viewItem({
            id: productId,
            name: productName,
            price: price
        });

        // 결제 시작 이벤트
        beginCheckout([{
            id: productId,
            name: productName,
            price: price
        }], price);

        // 기존 결제 로직 실행...
        if(invoicecker !== false && planToggle === false){
            dispatch(open({
                component:
                    <PopupPlanModel 
                        max_width={'480px'}
                        plan_type={'Pro'}
                        saleService={true}
                        longButton={lang === 0 ? '구독하기' : 'Subscribe'}
                        pay_card={mainCard ? true : false}
                        mainCard={mainCard}
                        nocardbuttonType={nocardbuttonType}
                        payData={payData}
                        seetnotviewer={true}
                        priceProMonth={priceProMonth}
                        priceProYear={priceProYear}
                        invoiceCode={invoicecker}
                        showWon={showWon}
                        couponlists={coupon}
                        PriceProYearsale={PriceProYearsale}

                    />    
            }));            
            return;
        }
        if (type === "pro") {
            dispatch(open({
                component:
                    <PopupPlanModel
                        max_width={'480px'}
                        plan_type={'Pro'}
                        /* free_plan={true} */
                        /* free_text={true} */
                        pay_card={mainCard ? true : false}
                        mainCard={mainCard}
                        nocardbuttonType={nocardbuttonType}
                        longButton={lang === 0 ? '결제하기' : 'Next'}
                        payData={payData}
                        seetnotviewer={true}
                        priceProMonth={priceProMonth}
                        priceProYear={priceProYear}
                        showWon={showWon}
                        couponlists={coupon}
                        PriceProYearsale={PriceProYearsale}
                    />
            }));

            // 결제 성공 시 구매 완료 이벤트
            purchase({
                id: Date.now().toString(),
                total: price,
                tax: price * 0.1,
                items: [{
                    id: productId,
                    name: productName,
                    price: price
                }]
            });
        }
        if (type === "art_pass") {
            dispatch(open({
                component:
                    <PopupPlanModel
                        max_width={'480px'}
                        plan_type={'Art Pass'}
                        free_plan={true}
                        free_text={true}
                        pay_card={mainCard ? true : false}
                        mainCard={mainCard}
                        nocardbuttonType={nocardbuttonType}
                        longButton={'구독하기'}
                        payData={payData}
                        showWon={showWon}
                    />
            }));
        }

        if (type === "All-In-One") {
            dispatch(open({
                component:
                    <PopupPlanModel
                        max_width={'480px'}
                        plan_type={'All-In-One'}
                        free_plan={true}
                        free_text={true}
                        pay_card={mainCard ? true : false}
                        mainCard={mainCard}
                        nocardbuttonType={nocardbuttonType}
                        longButton={'구독하기'}
                        payData={payData}
                        showWon={showWon}
                    />
            }));
        }

        if (type === "team") {
            dispatch(open({
                component:
                    <PopupPlanModel
                        max_width={'480px'}
                        plan_type={'Team'}
                        pay_card={mainCard ? true : false}
                        mainCard={mainCard}
                        nocardbuttonType={nocardbuttonType}
                        longButton={'구독하기'}
                        payData={payData}
                        showWon={showWon}
                    />
            }));
        }

        if (type === "school") {
            dispatch(open({
                component:
                    <PopupPlanModel
                        max_width={'500px'}
                        plan_type={'School'}
                        free_plan={true}
                        free_text={true}
                        pay_card={mainCard ? true : false}
                        mainCard={mainCard}
                        nocardbuttonType={nocardbuttonType}
                        longButton={'구독하기'}
                        payData={payData}
                        showWon={showWon}
                    />
            }));
        }

        if (type === "classroom") {
            dispatch(open({
                component:
                    <PopupPlanModel
                        max_width={'560px'}
                        plan_type={'Classroom'}
                        pay_card={mainCard ? true : false}
                        mainCard={mainCard}
                        nocardbuttonType={nocardbuttonType}
                        longButton={'구독하기'}
                        payData={payData}
                        showWon={showWon}
                    />
            }));
        }
    }

    const ClickAnswerView = (index) => {
        const newAnswerView = [...answerView];
        newAnswerView[index] = !newAnswerView[index];
        setAnswerView(newAnswerView);
    };

    const moneyFormat = (money) => {
        const formattedMoney = money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        if (showWon) {
            if (lang === 0) {
                return formattedMoney + '원';
            } else {
                return 'KRW ' + formattedMoney;
            }
        } else {
            return 'USD ' + formattedMoney;
        }
    };

    const moneyDiv = (category) => { // 0 : Pro, 1 : Art Pass, 2 : All-In-One
        const money = planToggle ?
            category === 0 ?
                priceProMonth
                :
                category === 1 ?
                    priceArtPassMonth
                    :
                    priceAllInOneMonth
            :
            category === 0 ?
                priceProYear
                :
                category === 1 ?
                    priceArtPassYear
                    :
                    priceAllInOneYear;
        const percent = category === 0 ? discountPro : category === 1 ? discountArtPass : discountAllInOne;
        //const percent = 11;
        let discountValue = percent > 0 ? (money - (money * percent / 100)) : money;
        if(invoicecker !== false && planToggle === false){
            discountValue = discountValue*0.5;
        }
        return (
            <>
                <div className="price" style={{ position: 'relative' }}>
                    {planToggle === false && invoicecker !== false &&
                        <div style={{ position: 'absolute', top: 10 }}><span style={{ fontSize: 18, textDecoration: 'line-through', color: '#999' }}>{moneyFormat((money).toFixed(2))}</span></div>
                    }
                    <div><span>{moneyFormat((discountValue).toFixed(2))}</span>{percent > 0 && <p>{moneyFormat((money).toFixed(2))}</p>}</div>
                    <div>
                        / {planToggle ? (lang === 0 ? '월(시트당)' : 'Monthly(Per Seat)') : (lang === 0 ? '연(시트당)' : 'Annual(Per Seat)')}
                    </div>
                </div>
            </>

        );
    }

    const SaleServicePop = () => {
        // if(planToggle === true){
        //     dispatch(open({
        //         component:
        //             <Popup01
        //                 max_width={'300px'}
        //                 x_btn={false}
        //                 text1={lang === 0 ? '연간 구독 상품만 신청하실 수 있습니다.' : 'You can only subscribe to the annual plan.'}
        //                 longButton={lang === 0 ? '확인' : 'OK'}
        //             />
        //     }));
        // } else {
            dispatch(open({
                component:
                    <PopupSaleService
                        max_width={'600px'}
                        x_btn={true}
                        priceProMonth={priceProMonth}
                        priceProYear={priceProYear}
                        planToggle={planToggle ? 1 : 0}
                        pay_card={mainCard ? true : false}
                        mainCard={mainCard}
                        nocardbuttonType={'Pro'}
                        payData={payData}
                        showWon={showWon}
                        setinvoicecker={setinvoicecker}
                    />
            }));
        //}

    }

    const getMainBody = () => {
        return (
            <>
                <div className="main_part padding">

                    <div className="title_box">
                        {lang === 0 ?
                            <>
                                나에게 맞는 플랜을 선택하여<br />3D 프로젝트의 생산성을 높이세요
                            </>
                            :
                            <>
                                Work Faster, Create More
                            </>
                        }

                    </div>

                    <div className="sub_title_box">
                        {lang === 0 ?
                            <>
                                지속적인 기능 업데이트와 전문적인 기술 지원으로<br />
                                여러분의 프로젝트에 든든한 파트너가 되어드립니다.
                            </>
                            :
                            <>
                                Everything you need for 3D success.
                            </>
                        }
                    </div>

                    <div className="plan_toggle_box" id="scrollmove">
                        <p
                            className={`title ${planToggle ? 'on' : ''}`}
                            onClick={() => {
                                setPlanToggle(true)
                            }}
                        >
                            Monthly
                        </p>

                        <input
                            type="checkbox"
                            id="toggle"
                            checked={!planToggle}
                            onChange={() => setPlanToggle(planToggle)}
                            hidden
                        />
                        <label
                            htmlFor="toggle"
                            className="toggleSwitch"
                            onClick={() => {
                                setPlanToggle(!planToggle)
                            }}
                        >
                            <span className="toggleButton"></span>
                        </label>

                        <p
                            className={`title ${!planToggle ? 'on' : ''}`}
                            onClick={() => {
                                setPlanToggle(false)
                            }}
                        >
                            Annual
                        </p>
                    </div>

                    <div className="plan_model_box" >
                        <div className="plan_model best">
                            <div class="group">
                                <div className="title main">
                                    <p>
                                        UModeler X Pro
                                    </p>
                                    <span>
                                        ⭐ {lang === 0 ? '추천' : 'Best'}
                                    </span>
                                </div>
                                {/* <p className="sub_title">ㅤ</p> */}
                                {moneyDiv(0)}

                                <div className="model_text">
                                    {lang === 0 ?
                                        <>
                                            최고의 환경에서 작업하세요.
                                        </>
                                        :
                                        <>
                                            Work in the best environment.
                                        </>
                                    }
                                </div>

                                <div className="model_pack">
                                    <p>
                                        <img src={require("../../assets/icon/chk_img.svg").default} />
                                        {lang === 0 ?
                                            <>
                                                모든 3D 에디터 패키지
                                            </>
                                            :
                                            <>
                                                Complete 3D Editor Package
                                            </>
                                        }

                                    </p>
                                    <p>
                                        <img src={require("../../assets/icon/chk_img.svg").default} />
                                        {lang === 0 ?
                                            <>
                                                지속적인 기능 추가
                                            </>
                                            :
                                            <>
                                                Ongoing Expansion of Editors
                                            </>
                                        }

                                    </p>
                                    {/* <p>
                                        <img src={require("../../assets/icon/chk_img.svg").default} />
                                        {lang === 0 ?
                                            <>
                                                우선 기술 지원
                                            </>
                                            :
                                            <>
                                                Priority Support
                                            </>
                                        }
                                    </p> */}
                                    <p>
                                        <img src={require("../../assets/icon/chk_img.svg").default} />
                                        {lang === 0 ?
                                        <>
                                            100만원 상당의 템플릿 라이브러리
                                        </>
                                        :
                                        <>
                                            $700 worth of Templates
                                        </>
                                        }
                                    </p>
                                </div>
                            </div>

                            <div class="group sub">
                                <div className="model_text sub">
                                    {lang === 0 ?
                                        'UModeler X의 최신 기능을 가장 빠르게 만날 수 있습니다. 외부 툴 없이 모든 3D 작업을 유니티 내에서 완료하고 100만원 상당의 템플릿 라이브러리를 활용하여 작업속도와 퀄리티를 높이세요.'
                                        :
                                        'Model, rig, and paint 3D assets directly in Unity — no extra software needed. Speed up your workflow with over USD 700 worth of ready-to-use templates and tools.'
                                    }
                                </div>

                                <div className="plan_btn_box">
                                    <button
                                        type="button"
                                        className="start_plan main"
                                        onClick={() => {
                                            // GA4 이벤트 추적 추가
                                            const eventName = paylist?.length > 0 ? 
                                                (paylist[0]?.ingstate*1 === 4 ? 'subscribe_again' : 'license_management') 
                                                : 'subscribe_now';
                                            const eventLabel = lang === 0 ? 
                                                (paylist?.length > 0 ? 
                                                    (paylist[0]?.ingstate*1 === 4 ? '다시 구독하기' : '라이선스 관리') 
                                                    : '바로 시작하기') 
                                                : 
                                                (paylist?.length > 0 ? 
                                                    (paylist[0]?.ingstate*1 === 4 ? 'Subscribe Again' : 'License Management') 
                                                    : 'Subscribe Now');
                                            
                                            gtag('event', eventName, {
                                                 'event_category': 'engagement',
                                                 'event_label': eventLabel
                                            });

                                            if(paylist?.length > 0){
                                                if(paylist[0]?.ingstate*1 === 4){
                                                    if (mainCard) {
                                                        payFunc("pro");
                                                    } else {
                                                        plusCardFunc("pro");
                                                        //handleSavedAccountAdded();
                                                    }
                                                } else {
                                                    navigate("/Licensing");
                                                }
                                            } else {
                                                if (mainCard) {
                                                    payFunc("pro");
                                                } else {
                                                    plusCardFunc("pro");
                                                    //handleSavedAccountAdded();
                                                }
                                            }
                                        }}
                                    >
                                        {paylist?.length > 0 ?
                                        <>
                                            {paylist[0]?.ingstate*1 === 4 ?
                                            <>{lang === 0 ? '다시 구독하기' : 'Subscribe Again'}</>
                                            :
                                            <>{lang === 0 ? '라이선스 관리' : 'License Management'}</>
                                            }
                                            
                                        </>
                                        :
                                        <>{lang === 0 ? '바로 시작하기' : 'Subscribe Now'}</>
                                        }
                                    </button>
                                    {/* <button
                    type="button"
                    className="start_plan main"
                    onClick={() => {

                    }}
                >
                    {lang === 0 ? '라이선스 관리' : 'License Management'}
                </button> */}

                                    {/* <button
                    type="button"
                    className="start_plan main"
                    onClick={() => {

                    }}
                >
                    {lang === 0 ? '다시 구독하기' : 'Subscribe Again'}
                </button> */}
                                    {/* - 미 로그인, 미 사용자 : 바로 시작하기
                - 이미 구독 중인 고객 : 라이선스 관리
                - 구독 했다가 종료 된 고객 : 다시 구독하기 */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {paylistcker?.length === 0 && invoicecker === false &&
                    <>
                    <div className="title_box price_support">
                        {lang === 0 ?
                            <>
                                이미 유니티 에셋 스토어에서<br />UModeler 혹은 UModeler X를 구매하셨나요?
                            </>
                            :
                            <>
                                Are you a UModeler or <br />UModeler X Plus user?
                            </>
                        }
                    </div>

                    <div className="sub_title_box">
                        {lang === 0 ?
                            <>
                                구매하셨던 Invoice no.를 입력하시면 50%의 할인된 금액으로 구독가능합니다.<br />
                                * 연간 구독 상품에 한함.
                            </>
                            :
                            <>
                                Enter your invoice number to get a 50% discount on your subscription.
                            </>
                        }
                    </div>

                    <button
                        type="button"
                        className="price_support_btn"
                        onClick={() => {
                            SaleServicePop();
                        }}
                    >
                        {lang === 0 ?
                            <>
                                50% 할인 혜택 받기
                            </>
                            :
                            <>
                                Upgrade
                            </>
                        }
                    </button>
                    </>
                    }

                    {/* <div className="sub_title_box">
                        {lang === 0 ?
                            <>
                                
                            </>
                            :
                            <>
                                * Vaild for annual payments only.
                            </>
                        }
                    </div> */}
                   
                    <div className="price_view"></div>

                    <div className="title_box price_page_title">
                        {lang === 0 ? '기능 비교' : 'Feature Comparison'}
                    </div>

                    <div className="main_price_box price_page">
                        <div className="price_tab set fill main other sub price_page" style={{ borderRadius: '20px 0 0 20px', /* minWidth: '222px' */ }}>
                            <p className="title top_set price_page"></p>
                            {/* <span className="sub_title">상업적 이용</span> */}
                            <span className="sub_title name">
                                {lang === 0 ?
                                    <>
                                        모델링, 리깅,<br />페인팅 필수 기능
                                    </>
                                    :
                                    <>
                                        Essential 3D Creation Features
                                    </>
                                }

                                <div
                                    className="other_view price"
                                    onMouseEnter={() => {
                                        setPlanOther(1);
                                    }}
                                    onMouseLeave={() => {
                                        setPlanOther(0)
                                    }}
                                >
                                    <img className={`${planOther == 1 ? 'show' : ''}`} src={require("../../assets/icon/other_icon.svg").default} />
                                    <div className={`comment_box btn1 pc ${planOther == 1 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                모델링, 리깅, 페인팅을 위한 필수 기능
                                            </>
                                            :
                                            <>
                                                Essential Features for Modeling, Rigging, and Painting
                                            </>
                                        }
                                    </div>

                                    <div className={`comment_box btn1 mobile ${planOther == 1 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                모델링, 리깅, 페인팅을<br />위한 필수 기능
                                            </>
                                            :
                                            <>
                                                Essential Features for <br />Modeling, Rigging, and Painting
                                            </>
                                        }
                                    </div>
                                </div>
                            </span>
                            {/* <span className="sub_title sub_option"><span className="set">└</span>스케치업 스타일 모델링</span>
        <span className="sub_title sub_option"><span className="set">└</span>핫스팟 텍스처링</span>
        <span className="sub_title sub_option"><span className="set">└</span>Curve Editor</span> */}
                            <span className="sub_title other name">
                                {lang === 0 ?
                                    <>
                                        플러스 <br />에디팅 패키지
                                    </>
                                    :
                                    <>
                                        Plus <br />Editing Package
                                    </>
                                }

                                <div
                                    className="other_view price"
                                    onMouseEnter={() => {
                                        setPlanOther(2);
                                    }}
                                    onMouseLeave={() => {
                                        setPlanOther(0)
                                    }}
                                >
                                    <img className={`${planOther == 2 ? 'show' : ''}`} src={require("../../assets/icon/other_icon.svg").default} />
                                    <div className={`comment_box btn2 pc ${planOther == 2 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                스케치기반 모델링, 핫스팟 텍스처링, OBJ/STL/PLY 익스포터,<br />
                                                Follow 툴, Array 툴/모디파이어, Multi UV 에디팅,<br />
                                                휴머노이드 아바타 지원 등 고급 기능
                                            </>
                                            :
                                            <>
                                                Advanced Features including Sketch-based Modeling, Hotspot Texturing, <br />
                                                OBJ/STL/PLY Exporter, Follow Tool, Array Tool/Modifier, <br />
                                                Multi-UV Editing, and Humanoid Avatar Support.
                                            </>
                                        }
                                    </div>

                                    <div className={`comment_box btn2 mobile ${planOther == 2 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                스케치기반 모델링, 핫스팟 텍스처링,<br />
                                                OBJ/STL/PLY 익스포터, Follow 툴,<br />
                                                Array 툴/모디파이어, Multi UV 에디팅,<br />
                                                휴머노이드 아바타 지원 등 고급 기능
                                            </>
                                            :
                                            <>
                                                Advanced Features including Sketch-based Modeling, <br />
                                                Hotspot Texturing, OBJ/STL/PLY Exporter, <br />
                                                Follow Tool, Array Tool/Modifier, <br />
                                                Multi-UV Editing, and Humanoid Avatar Support.
                                            </>
                                        }
                                    </div>
                                </div>
                            </span>
                            <span className="sub_title name">
                                {lang === 0 ?
                                    <>
                                        프로 <br />에디팅 패키지
                                    </>
                                    :
                                    <>
                                        Pro <br />Editing Package
                                    </>
                                }
                                <div
                                    className="other_view price"
                                    onMouseEnter={() => {
                                        setPlanOther(3);
                                    }}
                                    onMouseLeave={() => {
                                        setPlanOther(0)
                                    }}
                                >
                                    <img className={`${planOther == 3 ? 'show' : ''}`} src={require("../../assets/icon/other_icon.svg").default} />
                                    <div className={`comment_box btn3 pc ${planOther == 3 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                Curve 에디터, 2D Text to 3D Shape 툴,<br />
                                                Blend Shape 모드 등 추가 피처 제공
                                            </>
                                            :
                                            <>
                                                Enjoy additional features such as the Curve Editor, <br />
                                                2D Text to 3D Shape Tool, and Blend Shape Mode.
                                            </>
                                        }
                                    </div>

                                    <div className={`comment_box btn3 mobile ${planOther == 3 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                Curve 에디터, 2D Text to 3D Shape 툴,<br />
                                                Blend Shape 모드 등 추가 피처 제공
                                            </>
                                            :
                                            <>
                                                Enjoy additional features such as the Curve Editor, <br />
                                                2D Text to 3D Shape Tool, and Blend Shape Mode.
                                            </>
                                        }
                                    </div>
                                </div>
                            </span>
                            {/* <span className="sub_title sub_option"><span className="set">└</span>아이소메트릭 툴</span>
        <span className="sub_title sub_option"><span className="set">└</span>네온 빌리지</span> */}
                            <span className="sub_title other name">
                                {lang === 0 ?
                                    <>
                                        지속적인 <br />에디팅 피처 추가
                                    </>
                                    :
                                    <>
                                        Always the Latest Features
                                    </>
                                }
                                <div
                                    className="other_view price"
                                    onMouseEnter={() => {
                                        setPlanOther(4);
                                    }}
                                    onMouseLeave={() => {
                                        setPlanOther(0)
                                    }}
                                >
                                    <img className={`${planOther == 4 ? 'show' : ''}`} src={require("../../assets/icon/other_icon.svg").default} />
                                    <div className={`comment_box btn4 pc ${planOther == 4 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                새롭게 추가되는 3D 에디팅 피처를 지속적으로 업데이트
                                            </>
                                            :
                                            <>
                                                We continuously update with newly added 3D editing features.
                                            </>
                                        }
                                    </div>

                                    <div className={`comment_box btn4 mobile ${planOther == 4 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                새롭게 추가되는 3D 에디팅 피처를<br />
                                                지속적으로 업데이트
                                            </>
                                            :
                                            <>
                                                We continuously update with <br />
                                                newly added 3D editing features.
                                            </>
                                        }
                                    </div>
                                </div>
                            </span>
                            <span className="sub_title name">
                                {lang === 0 ?
                                        <>
                                            100만원 상당의 템플릿 <br />라이브러리
                                        </>
                                        :
                                        <>
                                            $700 Worth of <br />Templates
                                        </>
                                }
                                <div
                                    className="other_view price"
                                    onMouseEnter={() => {
                                        setPlanOther(5);
                                    }}
                                    onMouseLeave={() => {
                                        setPlanOther(0)
                                    }}
                                >
                                    <img className={`${planOther == 5 ? 'show' : ''}`} src={require("../../assets/icon/other_icon.svg").default} />
                                    <div className={`comment_box btn4 top pc ${planOther == 5 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                유니티 에셋 스토어에서 판매중인<br />
                                                20개 이상의 자사 3D 템플릿을 제공
                                            </>
                                            :
                                            <>
                                                Provides over 20 in-house 3D templates<br />available on the Unity Asset Store.
                                            </>
                                        }
                                    </div>

                                    <div className={`comment_box btn4 btn5 top mobile ${planOther == 5 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                유니티 에셋 스토어에서 판매중인<br />
                                                20개 이상의 자사 3D 템플릿을 제공
                                            </>
                                            :
                                            <>
                                                Provides over 20 in-house 3D templates<br />available on the Unity Asset Store.
                                            </>
                                        }
                                    </div>
                                </div>
                            </span>
                            {/* <span className="sub_title sub_option"><span className="set">└</span>무선 기술 지원</span>
        <span className="sub_title btm_last sub_option set">상업적 이용</span> */}

                            <span className="sub_title  name">
                                {lang === 0 ?
                                    <>
                                        라이선스 <br />관리 기능
                                    </>
                                    :
                                    <>
                                        License <br />Management Feature
                                    </>
                                }
                                <div
                                    className="other_view price"
                                    onMouseEnter={() => {
                                        setPlanOther(6);
                                    }}
                                    onMouseLeave={() => {
                                        setPlanOther(0)
                                    }}
                                >
                                    <img className={`${planOther == 6 ? 'show' : ''}`} src={require("../../assets/icon/other_icon.svg").default} />
                                    <div className={`comment_box btn4 top pc ${planOther == 6 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                팀 라이선스를 직접 관리할 수 있는 기능
                                            </>
                                            :
                                            <>
                                                A feature that allows you to directly manage team licenses.
                                            </>
                                        }
                                    </div>

                                    <div className={`comment_box btn4 btn6 top mobile ${planOther == 6 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                팀 라이선스를 직접 관리할 수 있는 기능
                                            </>
                                            :
                                            <>
                                                A feature that allows you to directly manage team licenses.
                                            </>
                                        }
                                    </div>
                                </div>
                            </span>

                            <span className="sub_title btm_last name">
                                {lang === 0 ?
                                    <>
                                        우선 기술 지원
                                    </>
                                    :
                                    <>
                                        Priority Technical Support
                                    </>
                                }
                                <div
                                    className="other_view price"
                                    onMouseEnter={() => {
                                        setPlanOther(7);
                                    }}
                                    onMouseLeave={() => {
                                        setPlanOther(0)
                                    }}
                                >
                                    <img className={`${planOther == 7 ? 'show' : ''}`} src={require("../../assets/icon/other_icon.svg").default} />
                                    <div className={`comment_box btn4 top pc ${planOther == 7 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                전용 채널을 통한 기술 지원
                                            </>
                                            :
                                            <>
                                                Technical support through a dedicated channel
                                            </>
                                        }
                                    </div>

                                    <div className={`comment_box btn4 btn6 top mobile ${planOther == 7 ? 'show' : ''} ${lang === 1 ? 'eng' : ''}`}>
                                        {lang === 0 ?
                                            <>
                                                전용 채널을 통한 기술 지원
                                            </>
                                            :
                                            <>
                                                Technical support through a dedicated channel
                                            </>
                                        }
                                    </div>
                                </div>
                            </span>

                        </div>

                        <div className="price_tab set">
                            <p className="title top_set price_page">Plus</p>
                            {/* <span className="sub_title"><img src={images?.option_chk}/></span> */}
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"></span>
                            <span className="sub_title"></span>
                            <span className="sub_title"></span>
                            <span className="sub_title"></span>
                            <span className="sub_title btm_last comment"></span>
                        </div>

                        <div className="price_tab set">
                            <p className="title top_set price_page">Pro</p>
                            {/* <span className="sub_title"><img src={images?.option_chk}/></span> */}
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"></span>
                            <span className="sub_title btm_last comment"></span>
                        </div>

                        <div className="price_tab right_last set">
                            <p className="title top_set right_last price_page">Enterprise</p>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title btm_last comment"><img src={images?.option_chk} /></span>
                        </div>
                    </div>

                    <div className="main_price_box price_page btn_box">
                        <div className="price_tab set btn one" style={{ gap: 0, alignItems: 'flex-start' }}>
                            <div className="btn_back" style={{ width: 260, display: width < 1050 ? 'none' : 'flex', alignItems: 'center' }}>
                                <button
                                    type="button"
                                    className="set2"
                                    onClick={() => {
                                        window.open("https://assetstore.unity.com/packages/tools/modeling/umodeler-x-plus-288107")
                                    }}
                                    style={{ width: 220 }}
                                >
                                    
                                    {lang === 0 ? '에셋 스토어' : 'Asset Store'}
                                </button>
                            </div>
                            <div className="btn_back" style={{ width: 260, display: width < 1050 ? 'none' : 'flex', alignItems: 'center' }}>
                                <button
                                    type="button"
                                    className="set1"
                                    onClick={() => {
                                        //window.open("https://assetstore.unity.com/publishers/26411")
                                        document.getElementById("scrollmove")?.scrollIntoView({ behavior: "smooth" });

                                    }}
                                    style={{ width: 220 }}
                                >
                                    {lang === 0 ? '바로 시작하기' : 'Try Now'}
                                </button>
                            </div>
                            <div className="btn_back" style={{ width: width < 1050 ? 220 : 260, alignItems: 'center' }}>
                                
                                <button
                                    type="button"
                                    className="set2"
                                    onClick={() => {
                                        window.open(lang === 0 ? "https://bit.ly/4ltBR2N" : "https://bit.ly/4jpbQQd")
                                    }}
                                    style={{ width: 220 }}
                                >
                                    {lang === 0 ? '도입 문의하기' : 'Adopt Now'}
                                </button>
                                
                            </div>
                          
                        </div>

                    </div>
                </div>

                <div className="main_part padding special">
                    <div className="title_box">
                        {lang === 0 ? '특별 라이선스 프로그램 및 지원' : 'Custom License Program and Support'}
                    </div>

                    <div className="sub_title_box">
                        {lang === 0 ?
                            <>
                                맞춤형 솔루션, SDK 재배포, 교육, 게임잼, 콘텐츠 제작 등 특별 라이선스나 지원이 필요하신가요?
                            </>
                            :
                            'Do you need custom solutions, SDK redistribution, training, game jams, or support for content creation?'
                        }
                    </div>

                    <div className="special_box">
                        <div className="content _1">
                            <p className="title">{lang === 0 ? '맞춤형 솔루션' : 'Tailored Solutions'}</p>
                            <div className="text_box">
                                {lang === 0 ? '특별한 요구에 맞춘 맞춤형 가격과 기능을 제공합니다. 다음 조건에 해당하면 신청할 수 있습니다.' : 'We offer tailored pricing and features to meet your specific needs. You can apply if you meet the following conditions.'}
                            </div>
                            <div className="condition">
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '다량의 라이선스가 필요합니다.' : 'You require a large number of licenses.'}</span>
                                </div>
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '전문화된 지원 또는 기능이 필요합니다.' : 'You need specialized support or features.'}</span>
                                </div>
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '기본 라이선싱 옵션을 초과하는 요구사항이 있습니다.' : 'Your requirements exceed the standard licensing options.'}</span>
                                </div>
                            </div>
                        </div>

                        <div className="content _2">
                            <p className="title">{lang === 0 ? '모딩 및 메타버스 SDK 재배포' : 'Modding SDK Redistributable'}</p>
                            <div className="text_box">
                                {lang === 0 ?
                                    '특정 제품의 모딩 SDK나 메타버스 플랫폼의 콘텐츠 제작 도구에 사용할 수 있는 재배포 가능 라이선스를 제공합니다. VRChat, 제페토, Rec Room과 같은 메타버스 플랫폼의 유니티 SDK나 게임의 모딩 도구 개발에 적합합니다. 단, 일반적인 게임 개발이나 범용 에셋 제작용으로는 사용할 수 없습니다. 자세한 내용을 원하면 별도로 문의 주시기 바랍니다.'
                                    :
                                    'We offer a redistributable license for modding SDKs or content creation tools for specific products, such as Unity SDKs for metaverse platforms like VRChat, ZEPETO, and Rec Room, or modding tools for game development. However, this license is not applicable for general game development or universal asset creation. Please contact us for more details.'
                                }
                            </div>
                        </div>

                        <div className="content right_last _3">
                            <p className="title">{lang === 0 ? '산업용 솔루션 제공' : 'Industrial Solutions Provided'}</p>
                            <div className="text_box">
                                {lang === 0 ?
                                    '게임 개발뿐만 아니라 건축, 시뮬레이션, 제조 등 다양한 산업군에 맞는 3D 모델링 솔루션을 제공합니다.'
                                    :
                                    'Providing 3D modeling solutions for various industries, including game development, architecture, simulation, and manufacturing.'
                                }
                            </div>
                        </div>

                        {/* <div className="content right_last _3">
        <p className="title">{lang === 0 ? '전용 디스코드 채널' : 'Exclusive Discord Channel'}</p>
        <div className="text_box">
            {lang === 0 ? 
                '연간 $1,000로 UModeler X 개발자와 직접 소통할 수 있는 전용 디스코드 채널을 제공합니다. 민감한 지원 문제나 엔터프라이즈 수준 논의를 위한 최적의 선택입니다. 해당 채널은 귀사의 팀만 사용할 수 있습니다.'
                :
                'For $1,000 annually, we provide an exclusive Discord channel where you can communicate directly with the UModeler X developers. This is the ideal choice for sensitive support issues or enterprise-level discussions. The channel will be available exclusively to your team.'
            }
        </div>
    </div> */}

                        <div className="content btm_last _4">
                            <p className="title">{lang === 0 ? '비영리 및 교육' : 'Non-Profit and Education'}</p>
                            <div className="text_box">
                                {lang === 0 ?
                                    <>
                                        비영리 및 <span onClick={() => { navigate(routes.Education) }}>교육</span> 기관은 무료 라이선스를 신청할 수 있습니다. 조건은 다음과 같습니다.
                                    </>
                                    :
                                    <>
                                        Non-profit and <span onClick={() => { navigate(routes.Education) }}>Educational</span> institutions can apply for a free license. The conditions are as follows.
                                    </>
                                }

                            </div>
                            <div className="condition">
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '공식적으로 등록된 비영리 또는 교육 기관입니다.' : 'It is an officially registered non-profit or educational institution.'}</span>
                                </div>
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '게임 개발, 메타버스, 교육에 종사합니다.' : 'It is involved in game development, the metaverse, or education.'}</span>
                                </div>
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '인증된 기관 이메일을 제공합니다.' : 'It provides a certified institutional email.'}</span>
                                </div>
                            </div>
                        </div>

                        <div className="content btm_last _5">
                            <p className="title">{lang === 0 ? '콘텐츠 제작자' : 'Content Creators'}</p>
                            <div className="text_box">
                                {lang === 0 ? '다음 조건을 충족하면 UModeler X Pro 라이선스를 무료로 받을 수 있습니다.' : 'You can receive a free UModeler X Pro license if you meet the following conditions.'}
                            </div>
                            <div className="condition">
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '구독자가 500명 이상입니다.' : 'You have more than 500 subscribers.'}</span>
                                </div>
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '6개월 이상 활동 중입니다.' : 'You have been active for more than 6 months.'}</span>
                                </div>
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? 'Unity 튜토리얼, 가이드 또는 교육 콘텐츠를 제작합니다.' : 'You create Unity tutorials, guides, or educational content.'}</span>
                                </div>
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '검증 가능한 이메일을 통해 연락합니다.' : 'You can be contacted through a verified email.'}</span>
                                </div>
                            </div>
                        </div>

                        <div className="content right_last btm_last _6">
                            <p className="title">{lang === 0 ? '게임잼' : 'GameJams'}</p>
                            <div className="text_box">
                                {lang === 0 ? '무료 UModeler X 라이선스로 게임잼을 빠르게 진행하세요. 다음 조건을 충족하면 신청할 수 있습니다.' : 'Quickly host a GameJam with a free UModeler X license. You can apply if you meet the following conditions.'}
                            </div>
                            <div className="condition">
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '게임잼이 신뢰할 수 있는 기관에 의해 주최됩니다.' : 'The Game Jam is organized by a reputable institution.'}</span>
                                </div>
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '물리적 장소에서 개최되고 접근 가능합니다.' : 'It is held at a physical location and is accessible.'}</span>
                                </div>
                                <div>
                                    <p>•</p>
                                    <span>{lang === 0 ? '주최자가 공식 이메일을 통해 우리와 연락합니다.' : 'The organizer contacts us through an official email.'}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button
                        type="button"
                        className="special"
                        onClick={() => {
                            navigate(routes.Inquiry);
                        }}
                    >
                        {lang === 0 ? '문의하기' : 'Contact Us'}
                    </button>
                </div>

                <div className="main_part padding">
                    <div className="title_box">
                        {lang === 0 ? '자주 묻는 질문' : 'FAQ'}
                    </div><br /><br />

                    <div className="question_box">
                        {questionSample.map((x, i) => (
                            <div
                                key={i}
                                className={`question_list ${answerView[i] ? 'on' : ''}`}
                                onClick={() => {
                                    ClickAnswerView(i)
                                    /* console.log(i); */
                                }}
                            >
                                <b>{lang === 0 ? x : questionSampleEn[i]}</b>

                                {answerView[i] &&
                                    <div className="answer">
                                        <div
                                            className="answer_text_box"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                            }}
                                        >
                                            {i === 0 &&
                                                <>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    Pro는 Plus의 모든 기능을 포함하며, 추가적으로 Curve 컴포넌트, Quadify 툴, Edge Constraints 툴, Text to 3D 컴포넌트 등 더 많은 확장 기능을 제공합니다. 또한 구독 기간 중 지속적인 기능 업데이트가 이루어집니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Pro includes all Plus features and adds advanced tools like Curve Component, Quadify Tool, Edge Constraints, and Text to 3D. Continuous feature updates are provided during the subscription period.
                                                                </>
                                                            }

                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    Pro는 구독 모델로 UModeler 웹사이트에서 누구나 제한 없이 구독할 수 있습니다. 반면, Plus는 Unity Asset Store에서 구매 가능하며, 연 매출 20만 달러 미만의 개인 및 기업만 사용할 수 있습니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Pro is a subscription model available on the UModeler website without limitations, while Plus is a one-time purchase on the Unity Asset Store for individuals/companies with revenue under $200,000 per year.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    더 자세한 비교는
                                                                    <span
                                                                        onClick={() => {
                                                                            if (lang === 0) {
                                                                                window.open('https://docs.umodeler.com/ko/docs/faq/');
                                                                            } else {
                                                                                window.open('https://docs.umodeler.com/docs/faq/')
                                                                            }
                                                                        }}
                                                                    >
                                                                        공식 매뉴얼의 FAQ
                                                                    </span>
                                                                    를 참고해 주세요.
                                                                </>
                                                                :
                                                                <>
                                                                    See the
                                                                    <span
                                                                        onClick={() => {
                                                                            if (lang === 0) {
                                                                                window.open('https://docs.umodeler.com/ko/docs/faq/');
                                                                            } else {
                                                                                window.open('https://docs.umodeler.com/docs/faq/')
                                                                            }
                                                                        }}
                                                                    >
                                                                        official manual FAQ
                                                                    </span>
                                                                    for details.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 1 &&
                                                <>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    기존 UModeler 혹은 UModeler X Plus를 사용 중인 경우 Pro 연 구독 시 특별 업그레이드 할인 혜택이 제공됩니다. (쿠폰과 중복 가능)
                                                                </>
                                                                :
                                                                <>
                                                                    Yes! Existing users get a special upgrade discount when subscribing to Pro (stackable with coupons).
                                                                </>
                                                            }
                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    업그레이드 할인을 위해서는
                                                                    <span
                                                                        onClick={() => {
                                                                            navigate(routes.Price);
                                                                            window.scrollTo(0, 0);
                                                                        }}
                                                                    >
                                                                        가격 페이지
                                                                    </span>
                                                                    를 참고해 주세요.
                                                                </>
                                                                :
                                                                <>
                                                                    Check the
                                                                    <span
                                                                        onClick={() => {
                                                                            navigate(routes.Price);
                                                                            window.scrollTo(0, 0);
                                                                        }}
                                                                    >
                                                                        pricing page
                                                                    </span>
                                                                    for upgrade details.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 2 &&
                                                <>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    UModeler X Pro 라이선스는 결제 전 테스트해볼 수 있도록 무료 사용 기간(Trial Period)을 제공합니다.
                                                                </>
                                                                :
                                                                <>
                                                                    UModeler X Pro offers a free trial period before payment.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    UModeler X는 기본적으로 환불이 불가능하지만, 특별한 사유가 있을 경우
                                                                    <span
                                                                        onClick={() => {
                                                                            navigate(routes.Inquiry);
                                                                            window.scrollTo(0, 0);
                                                                        }}
                                                                    >
                                                                        문의
                                                                    </span>
                                                                    를 통해 도움을 드릴 수 있습니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Refunds are generally not available for UModeler X, but feel free to 
                                                                    <span
                                                                        onClick={() => {
                                                                            navigate(routes.Inquiry);
                                                                            window.scrollTo(0, 0);
                                                                        }}
                                                                    >
                                                                        contact us
                                                                    </span> 
                                                                    for special cases.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 3 &&
                                                <>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    네, 교육 기관이나 기업 고객에게는 대량 구매 시 할인 혜택을 제공합니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Yes, bulk discounts are available for educational or enterprise customers.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    관련된 문의 사항은 contact.support@umodeler.com 혹은
                                                                    <span
                                                                        onClick={() => {
                                                                            navigate(routes.Inquiry);
                                                                            window.scrollTo(0, 0);
                                                                        }}
                                                                    >
                                                                        여기
                                                                    </span>
                                                                    로 연락해 주시기 바랍니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Contact us at contact.support@umodeler.com or 
                                                                    <span
                                                                        onClick={() => {
                                                                            navigate(routes.Inquiry);
                                                                            window.scrollTo(0, 0);
                                                                        }}
                                                                    >
                                                                        here
                                                                    </span>
                                                                    for details
                                                                </>
                                                            }


                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    Enterprise, Industry 고객은
                                                                    <span
                                                                        onClick={() => {
                                                                            navigate(routes.Licensing);
                                                                        }}
                                                                        style={{ padding: '0' }}
                                                                    >
                                                                        [라이선스 관리]
                                                                    </span>
                                                                    에서 대량의 라이선스를 조직 단위로 손쉽게 관리할 수 있는 기능을 제공하고 있습니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Enterprise users can easily manage licenses through
                                                                     <span
                                                                        onClick={() => {
                                                                            navigate(routes.Licensing);
                                                                        }}
                                                                        style={{ padding: '0' }}
                                                                    >
                                                                        [License Management]
                                                                    </span>.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 4 &&
                                                <>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    Unity 2022부터 최신 Unity 6까지 모든 버전을 지원합니다.
                                                                </>
                                                                :
                                                                <>
                                                                    UModeler X supports Unity 2022 and the latest Unity 6.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 5 &&
                                                <>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    고객 지원은 이메일과 디스코드를 통해 제공됩니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Support is available via email or Discord.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                문제가 발생하거나 도움이 필요하신 경우,
                                                                <span
                                                                    className="right"
                                                                    onClick={() => {
                                                                        navigate(routes.Inquiry);
                                                                        window.scrollTo(0, 0);
                                                                    }}
                                                                >
                                                                    여기
                                                                </span>
                                                                혹은 아래의 채널을 통해 언제든지 문의해 주세요.
                                                                </>
                                                                :
                                                                <>
                                                                    For any issues or help, contact us <span
                                                                    className="right"
                                                                    onClick={() => {
                                                                        navigate(routes.Inquiry);
                                                                        window.scrollTo(0, 0);
                                                                    }}
                                                                >
                                                                    here
                                                                </span> or through:
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            <span
                                                                className="none"
                                                                onClick={() => {
                                                                    window.open('https://discord.gg/qv54qkPdgy​');
                                                                }}
                                                            >

                                                                {lang === 0 ?
                                                                    <>
                                                                        디스코드
                                                                    </>
                                                                    :
                                                                    <>
                                                                        Discord
                                                                    </>
                                                                }

                                                            </span>
                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    이메일: contact.support@umodeler.com
                                                                </>
                                                                :
                                                                <>
                                                                    Email: contact.support@umodeler.com
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 6 &&
                                                <>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    Unity를 구동할 수 있는 기본 사양이면 충분히 사용할 수 있습니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Any PC that runs Unity is enough.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    권장 사양은 Unity의 시스템 요구 사항에 따릅니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Recommended specs follow Unity's system requirements.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    자세한 내용은 유니티 매뉴얼을 참고해 주시기 바랍니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Please check the Unity manual.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 7 &&
                                                <>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    UModeler X의 사용자 가이드와 다양한 튜토리얼은
                                                                    <span
                                                                        onClick={() => {
                                                                            navigate(routes.Support);
                                                                            window.scrollTo(0, 0);
                                                                        }}
                                                                    >
                                                                        학습 및 지원
                                                                    </span>
                                                                    에서 확인할 수 있습니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Find guides and tutorials in the <span
                                                                        onClick={() => {
                                                                            navigate(routes.Support);
                                                                            window.scrollTo(0, 0);
                                                                        }}
                                                                    >
                                                                        Learning & Support
                                                                    </span>
                                                                    section.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    또한,
                                                                    <span
                                                                        className="right"
                                                                        onClick={() => {
                                                                            window.open('https://www.youtube.com/@UModeler')
                                                                        }}
                                                                    >
                                                                        유튜브
                                                                    </span>
                                                                    채널과
                                                                    <span
                                                                        className="right"
                                                                        onClick={() => {
                                                                            window.open('https://discord.gg/qv54qkPdgy​');
                                                                        }}
                                                                    >
                                                                        디스코드
                                                                    </span>
                                                                    커뮤니티에서도 유용한 자료와 팁을 제공합니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Useful resources and tips are also on our
                                                                    <span
                                                                        className="right"
                                                                        onClick={() => {
                                                                            window.open('https://www.youtube.com/@UModeler')
                                                                        }}
                                                                    >
                                                                        YouTube
                                                                    </span> channel and <span
                                                                        className="right"
                                                                        onClick={() => {
                                                                            window.open('https://discord.gg/qv54qkPdgy​');
                                                                        }}
                                                                    >
                                                                        Discord
                                                                    </span>.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 8 &&
                                                <>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    Unity 엔진에서 직접 3D 모델링이 가능한 UModeler X는 별도의 외부 프로그램 없이도 실시간으로 3D 에셋을 제작하고 수정할 수 있어, 더욱 효율적인 워크플로우를 제공합니다.
                                                                </>
                                                                :
                                                                <>
                                                                    UModeler X allows real-time 3D modeling inside Unity without external tools, providing a more efficient workflow.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 9 &&
                                                <>
                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    UModeler X는 전세계 초중고 및 대학교 학생 및 교사를 위한 School 라이선스를 제공합니다.
                                                                </>
                                                                :
                                                                <>
                                                                    UModeler X offers a School License for students and schools.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    School 라이선스는 파트너 기관의 도메인 이메일을 통해서 무료로 제공되며,
                                                                    <span
                                                                        onClick={() => {
                                                                            navigate(routes.Education);
                                                                            window.scrollTo(0, 0);
                                                                        }}
                                                                    >
                                                                        School 페이지
                                                                    </span>
                                                                    를 통해 파트너 기관 등록 신청을 진행할 수 있습니다. 파트너 기관이 등록되지 않은 학생 및 교사는 재학증명서 혹은 재직증명서를 통해 인증하여 School 라이선스를 발급 받을 수 있습니다.
                                                                </>
                                                                :
                                                                <>
                                                                    The School license is provided free of charge through the partner institution's domain email, and you can apply for partner registration through the
                                                                     <span
                                                                        onClick={() => {
                                                                            navigate(routes.Education);
                                                                            window.scrollTo(0, 0);
                                                                        }}
                                                                    >
                                                                        School Page
                                                                    </span>. Non-partner students/teachers can apply with proof of enrollment or employment.
                                                                </>
                                                            }

                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <p>•</p>
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    School 라이선스는 상업적으로 이용할 수 없습니다.
                                                                </>
                                                                :
                                                                <>
                                                                    School licenses are not for commercial use.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {/* {answerSample[1].map((x, i) => (
                            <div key={i} className="text">
                                <p>•</p>
                                <span>
                                    {x}
                                </span>
                            </div>
                        ))} */}
                                        </div>
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </>
        )
    }

    const plusCardFunc = async (tyeps = '') => {
        if (!mbData?.idx) {
            navigate('/Login');
            return;
        }
        setnocardbuttonType(tyeps);
        // handleSavedAccountAdded({}, tyeps);
        // return;
        setpaypopflag(true);
        const result = await API.xsollaApis("user/XsolaApiTokens", { idx: mbData?.idx });
        console.log("result : ", result?.tokens);
        const iframe = document.getElementById("paystation-frame");
        const container = document.getElementById("paystation-container");

        iframe.src = `https://secure.xsolla.com/paystation4/?token=${result?.tokens}`;
        container.style.display = "block";

        setintervals(setInterval(async () => {
            const ckresult = await API.xsollaApis("user/XsolaAddchecking", { idx: mbData?.idx });
            console.log(ckresult?.result);
            if (ckresult?.status === 200) {
                setintervals((val) => {
                    clearInterval(val);
                });
                handleSavedAccountAdded(ckresult?.result, tyeps);
            }
            if (ckresult?.status === 400) {
                dispatch(open({
                    component:
                        <Popup01
                            max_width={'300px'}
                            x_btn={false}
                            text1={result?.message}
                            longButton={lang === 0 ? '확인' : 'OK'}
                        />
                }));
                payclose();
                setintervals((val) => {
                    clearInterval(val);
                });
            }

        }, 1000));
    }
    const payclose = () => {
        setintervals((val) => {
            clearInterval(val);
        });
        setpaypopflag(false);
        cardData();
    }
    const handleMessage = (event) => {
        return;
        // 모든 메시지 출력
        console.log("📨 수신된 postMessage1:", event.origin);
        console.log("📨 수신된 postMessage2:", event.data);

        // handleSavedAccountAdded({});
        // return;

        // origin 확인
        if (!PAYSTATION_ORIGINS.includes(event.origin)) return;

        let message = event.data;
        console.log(message);
        // 문자열인 경우 파싱 시도
        if (typeof message === 'string') {
            try {
                message = JSON.parse(message.replace(/'/g, '"'));
            } catch (error) {
                console.warn("⚠️ 메시지 파싱 실패:", error);
                payclose();
                return;
            }
        }

        // 이벤트별 처리
        if (message.command === 'add_saved_account') {
            savedAccountAdded = true;
            console.log("✅ add_saved_account 이벤트 수신");
            handleSavedAccountAdded(message.data, nocardbuttonType);
        }

        if (message.status === 'close') {
            console.log("❌ close 이벤트 수신");
            if (!savedAccountAdded) {
                payclose();
                //alert("❌ 저장된 결제 수단 추가 실패");
            }
            document.getElementById("paystation-container").style.display = "none";
            document.getElementById("paystation-frame").src = "";
        }

        if (message.status === 'done') {
            console.log("✅ 결제 완료 이벤트 수신");
        }

        if (message.status === 'error') {
            console.error("🚨 오류 이벤트 수신:", message);
        }
    }

    const handleSavedAccountAdded = async (account, tyeps = '') => {
        // let sender = {
        //     idx: mbData?.idx,
        //     cardName: account.name,
        //     carduserid: account.user_id,
        // }
        let sender = {
            idx: mbData?.idx,
            cardName: account.name,
            carduserid: account.id, //or invoice_id
        }
        const result = await API.xsollaApis("user/XsolaCardAdd", sender);
        // document.getElementById("paystation-container").style.display = "none";
        // document.getElementById("paystation-frame").src = "";
        console.log(result);

        if (result?.status === 200) {
            payclose();
            setTimeout(() => {
                payFunc(tyeps);
            }, 300);
        }
    }

    return (
        <>
            <div className="main_back">

                <div className="main_part main_banner">
                    <div
                        className="video_view main"
                        style={{
                            backgroundImage: `url('${images?.pricetopbg}')`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}
                    >
                        <div className="banner_text_box" style={{ marginTop: 0 }}>
                            <p style={{ color: '#000' }}>
                                {
                                    isEmpty ? (
                                        lang === 0 ?
                                            <>
                                                UModeler X Pro / <h6 style={{ display: 'inline', fontWeight: 'normal' }}>March 31</h6><br />
                                            </>
                                            :
                                            <>
                                                UModeler X Pro / <h6 style={{ display: 'inline', fontWeight: 'normal' }}>March 31</h6><br />
                                            </>
                                    ) : (
                                        lang === 0 ?
                                            <>
                                                UModeler X Pro - 14일간 무료 체험하세요!
                                            </>
                                            :
                                            <>
                                                Try UModeler X Pro – 14 Days Free
                                            </>
                                    )
                                }
                            </p>
                            <div className="sub_title_box">
                                {
                                    isEmpty ? (
                                        lang === 0 ?
                                            <>
                                                뉴스레터를 구독하고 50% 할인 쿠폰을 받아보세요.
                                            </>
                                            :
                                            <>
                                                Subscribe to our newsletter and receive a 50% discount coupon.
                                            </>
                                    ) : (
                                        lang === 0 ?
                                            <>
                                                카드 등록 없이 설치만 하면 바로 시작할 수 있어요.
                                            </>
                                            :
                                            <>
                                                 Just download, install, and start – no card required.
                                            </>
                                    )
                                }
                            </div>

                            <button
                                type="button"
                                className="custom_btn price_page_top"
                                style={{ minWidth: 'unset' }}
                                onClick={() => {
                                    const eventName = isEmpty ? 'subscribe' : 'download_hub_price';
                                    const eventLabel = isEmpty ? 
                                        (lang === 0 ? '뉴스레터 구독하기' : 'Subscribe Now') : 
                                        (lang === 0 ? '다운로드' : 'Download');
                                    
                                    gtag('event', eventName, {
                                        'event_category': 'engagement',
                                        'event_label': eventLabel
                                    });
                                    
                                    const url = isEmpty ?
                                        (lang === 0 ? 'https://bit.ly/3QK7WFn' : 'https://bit.ly/41JsuUZ') :
                                        'https://bit.ly/3FvWPO8';
                                    const newWindow = window.open(url, '_blank');
                                    if (newWindow) {
                                        setTimeout(() => {
                                            newWindow.close();
                                        }, 3000000); // 3초 후에 창을 닫습니다. 필요에 따라 시간을 조정하세요.
                                    }
                                }}
                            >
                                {isEmpty ?
                                    lang === 0 ? '뉴스레터 구독하기' : 'Subscribe Now'
                                    :
                                    lang === 0 ? '다운로드' : 'Download'
                                }
                            </button>

                        </div>
                    </div>
                </div>

                {
                    !isEmpty && (
                        getMainBody()
                    )
                }


            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
            {paypopflag === true &&
                <div
                    style={{
                        position: 'fixed', left: 0, top: 0, width: '100%', height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}
                >
                    <button
                        className='payclose'
                        onClick={() => {
                            payclose();
                        }}
                    >
                        <img src={require("../../assets/icon/x.svg").default} />
                    </button>
                    <div id="paystation-container" >
                        <iframe id="paystation-frame" style={{ width: '100%', height: '100%' }}></iframe>
                    </div>
                </div>}
        </>
    );
}
